import {LocaleObject} from "yup";

export default {
    mixed: {
        required: 'Le champs est requis',
    },
    string: {
        email: 'Le format de l\'email est incorrect',
    },
} as LocaleObject
